import React from "react";
import { Box, IconButton, SvgIcon, useTheme, makeStyles } from "@material-ui/core";
import HelpOutlinedIcon from "@material-ui/icons/HelpOutlined";
import Popup from "../components/Popup";
import { Theme } from "../.themes";

export type HelpProps = {
  title?: string;
  description?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  box: { ...theme.helpIconButton?.box },
}));

export const HelpIcon: React.FC<HelpProps> = (props: HelpProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles(theme);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const element = (theme.icons?.helpIcon && <SvgIcon fontSize='small'>{theme.icons?.helpIcon}</SvgIcon>) ?? (
    <HelpOutlinedIcon fontSize='small'></HelpOutlinedIcon>
  );

  return (
    <Box className={classes.box}>
      <IconButton onClick={openPopover} size='small'>
        {element}
      </IconButton>
      <Popup
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        title={props.title}
        description={props.description}
      />
    </Box>
  );
};

export default HelpIcon;
